import React from "react";
import styled, { keyframes } from "styled-components";

const dripping = keyframes`
from {
	transform: skew(0);
  opacity: 100%;
}
to {
  transform: translate(0, 2000%) rotate3d(0, 1, 0.2, 90deg);
  opacity: 0%;
}
`;
const DrippingSpan = styled.span`
  display: inline-block;
  animation: ${dripping} ${(props) => props.duration}s ease-in-out
    ${(props) => props.delay}s 1 normal forwards;
`;

const StaticSpan = styled.span`
  display: inline-block;
`;

function DrippingAnimation({
  dripProb,
  animationDuration,
  randomDurationScale,
  animationDelay,
  randomDelayScale,
  ...props
}) {
  return (
    <>
      {React.Children.map(props.children, (child, index) => {
        if (Math.random() < dripProb) {
          return (
            <DrippingSpan
              key={index}
              duration={
                Math.pow(Math.random(), 3) * randomDurationScale +
                animationDuration
              }
              delay={
                Math.pow(Math.random(), 3) * randomDelayScale + animationDelay
                // (1.0 / (index * index)) * React.Children.count(props.children) +
                // 10 * Math.random()
              }
            >
              {child}
            </DrippingSpan>
          );
        } else {
          return <StaticSpan>{child}</StaticSpan>;
        }
      })}
    </>
  );
}

export default DrippingAnimation;

